export default __webpack_public_path__ + "static/media/invite_friend.7b368ab2.png";